import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "mapContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"position":"fixed","display":"block","top":"250px","width":"80%","left":"100px","z-index":"2000"} })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdDocDisplayMap = _resolveComponent("AdDocDisplayMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showMapModal === true && _ctx.getDisplayMapCenter !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "m-modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
          }, [
            _createVNode(_component_AdDocDisplayMap)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}